import { request } from '@umijs/max';

/** 用户注册 */
export async function register(params: MIAOYING.RegisterParams) {
  return request<MIAOYING.Response<MIAOYING.RegisterResult>>('/api/web/register', {
    method: 'POST',
    data: params,
  });
}

/** 用户登录 */
export async function login(params: MIAOYING.LoginParams) {
  return request<MIAOYING.Response<MIAOYING.LoginResult>>('/api/web/login', {
    method: 'POST',
    data: params,
  });
}

/** 获取当前用户信息 */
export async function getCurrentUser() {
  return request<MIAOYING.Response<MIAOYING.Account>>('/api/web/user/profile', {
    method: 'GET',
  });
}

/** 更新个人信息 */
export async function updateProfile(params: MIAOYING.UpdateProfileParams) {
  return request<MIAOYING.Response>('/api/web/user/profile', {
    method: 'PUT',
    data: params,
  });
}

/** 实名认证 */
export async function verifyRealName(params: MIAOYING.VerifyParams) {
  return request<MIAOYING.Response>('/api/web/user/verify', {
    method: 'POST',
    data: params,
  });
}
